<template>
  <span class="blink_me" v-if="runningTime">{{ runningTime  | formatTime }}</span>
</template>

<script>
import formatterMixin from "@/mixins/formatterMixin";

export default {
  mixins: [formatterMixin],
  props: {
    startTime: String,
  },
  data: () => ({
    runningTime: null,
    timer: null,
  }),
  computed: {},
  watch: {},
  mounted() {
    this.timer = setInterval(() => {
      this.runningTime = this.calculateTime(this.startTime);
    }, 1000);
  },
  beforeDestroy() {
    delete this.timer;
  },
  methods: {
    calculateTime(startTime) {
      if (!this.startTime) {
        return null;
      }

      const start = this.momentLocal(startTime);
      const stop = this.momentLocal(new Date());
      const ms = Math.abs(start.diff(stop, 'second'));
      return parseInt(ms);
    },
  },
};
</script>
